import { useCallback } from 'react';

import { IItem, IItemKey } from 'api/catalog/models';
import { renderBoolean, renderStringArrayValue } from 'utils/rendering';
import { toTitleCase } from 'utils/toTitleCase';

import { useHostSystems } from './useHostSystems';

export const useItemRendering = () => {
  const { getLabel } = useHostSystems();

  const getCommonAttributeRender = useCallback(
    (item: IItem, key: IItemKey) => {
      switch (key) {
        case 'hostSystem':
          return `${getLabel(item[key])} (${item[key]})`;
        case 'itemAttributes':
        case 'promoAtDcNumbers':
        case 'sugarTaxZipcodes':
        case 'bottleDepositStates':
          return renderStringArrayValue(item[key]);
        case 'isSupplierShipped':
        case 'isVariableWeight':
        case 'isLongLeadItem':
        case 'isPrivateLabel':
          return renderBoolean(item[key]);
        case 'description':
        case 'departmentName':
        case 'categoryName':
        case 'subcategoryName':
        case 'brandName':
        case 'title':
        case 'countryOfOriginName':
          return toTitleCase(item[key]);
        case 'additionalDetails':
        case 'itemAtOtherDcs':
          return null;
        default:
          return item[key];
      }
    },
    [getLabel]
  );

  return { getCommonAttributeRender };
};
